module.exports = function (app) {
	'use strict';

	require('./benefitBooklets')(app);
	require('./groupContracts')(app);
	require('./idCards')(app);
	require('./preventiveMedications')(app);
	require('./spendingAccounts')(app);
	require('./changePcp')(app);
	require('./summaryOfBenefits')(app);
	require('./visionProvider')(app);

	app.controller('pages.assistEmployees', ['$scope', '$state', 'navigation','services', 'link', 'modal', 'sessionData', 'coremetrics',
		function ($scope, $state, navigation, services, link, modal, sessionData, coremetrics) {

			if ((sessionData.entitlements.clientStatus.cancelled == true)
				&& (!sessionData.cancelledClientHasAgreed)) {
				$state.go('cancelledConditions');
			}

			$scope.assistEmployeesLandingLinks = [
				{
					heading: 'Employee Resources',
					links: navigation.data.employeeResources
				},
				{
					heading: 'Providers',
					links: navigation.data.providers
				},
				{
					heading: 'Spending Account',
					links: navigation.data.spendingAccount
				},
				{
					heading: 'Educational Tools',
					links: navigation.data.educationalTools
				}
			];

			$scope.sidebar = {
				breadCrumb: {
					primary: {
						title: 'Assist Employees',
						state: 'assistEmployees'
					}
				}
			};

		

			// $scope.ssoAcclaris = function() {
			// 	var ssoURL = success.data.payload.ssoUrl;
			// 	var urlAppend = (ssoURL.indexOf("?") > -1) ? "&" : "?";
			// 	var sitePrmotionTag = "cm_sp=Health%20Analytics-_-MedeAnalytics-_-MedeAnalytics";
			// 	// var theUrl = ssoURL + urlAppend + sitePrmotionTag;
			// 	var theUrl = ssoURL + urlAppend;
			// 	var ssoFormConfig = {
			// 		"name": "InvisibleSsoSvcsFormName",
			// 		"id": "InvisibleSsoSvcsFormId",
			// 		"formTarget": "InvisibleSsoSvcs",
			// 		"method": "POST",
			// 		"action": theUrl,
			// 		"target": "_blank",
			// 		"inputs": {}
			// 	};
			// 	var formParams = success.data.payload.ssoFormParams;
			// 	for (var i = 0; i < formParams.length; i++) {
			// 		ssoFormConfig.inputs[formParams[i].name] = formParams[i].value;
			// 	}
			// 	// next line sends the user where they should go
			// 	invisibleFormService.submit(ssoFormConfig);
			// };
			(function setVisionAndDentalLinks() {
				var providerlinks = navigation.data.providers || [];
                var removeLink = function(linkId) {
                    for (var s = 0; s < navigation.data.providers.length; ++s) {
                        if (navigation.data.providers[s].type && navigation.data.providers[s].type === linkId) {
                            navigation.data.providers.splice(s, 1);
                            break;
                        }
                    }
                };

				if(providerlinks.length){
                    services.eprsvc.visionAndDental().fetch().then(
                        function(Response) {
                            if (Response.data && Response.data.payload) {
                                var payload = Response.data.payload;
                                  if(!payload.vision){
                                  	var type = 'vision';
                                      removeLink(type);
								  }
                                if(!payload.dental){
                                  	var dent = 'dental'
                                    removeLink(dent);
                                }

                            }

						});
				}

            })

			(function setAcclarisAlegeusLinks() {


				var spendingLinks = navigation.data.spendingAccount || [];


				if (spendingLinks.length) {
                    services.eprsvc.spendingAccountVendors().fetch().then(
                        function(vendorsResponse) {
                            if (vendorsResponse.data && vendorsResponse.data.payload) {
								var payload = vendorsResponse.data.payload;

                                var current = payload.currentVendors || [];
                                var previous = payload.previousVendors || [];
                                var future = payload.futureVendors || [];
                                var allVendors = current.concat(previous); // ignoring futureVendors for now
                                var allVendors1 = allVendors.concat(future);
								var displayedLinks = [];


								var hasAlegeus = function(vendors) {
									return vendors.indexOf('12') !== -1;
								};



								var setLinkLabel = function(linkId, label) {
									for (var s = 0; s < navigation.data.spendingAccount.length; ++s) {
										if (navigation.data.spendingAccount[s].id === linkId) {
											navigation.data.spendingAccount[s].label = label;
											break;
										}
									}
								};
                                var removeLink = function(linkId) {
                                    for (var s = 0; s < navigation.data.spendingAccount.length; ++s) {
                                        if (navigation.data.spendingAccount[s].id === linkId) {
                                            navigation.data.spendingAccount.splice(s, 1);
                                            break;
                                        }
                                    }
                                };


								if (hasAlegeus(allVendors1)) {
                                    var superUser = sessionData.employerInfo.planAdministratorEntitlements.userLevelEntitlements['Super User Role'];;
                                    var researchOnly = sessionData.employerInfo.planAdministratorEntitlements.userLevelEntitlements['Research Only Role'];
                                    if(superUser || researchOnly){
                                        displayedLinks.push( link.get('alegeusSpendingAccountLink') );

                                    }
                                    else{
                                        removeLink('alegeusSpendingAccountLink');
									}




								}
								else {
									removeLink('alegeusSpendingAccountLink');
								}


								if (displayedLinks.length === 0) {
									'no op';
								}
								else if (displayedLinks.length === 1 && hasAlegeus(allVendors1) ) {
									displayedLinks[0].label = 'Spending Account';
								}
                            }
                        },
                        function (err) {
                            console.error(err);
                            var removeLink = function(linkId) {
                                for (var s = 0; s < navigation.data.spendingAccount.length; ++s) {
                                    if (navigation.data.spendingAccount[s].id === linkId) {
                                        navigation.data.spendingAccount.splice(s, 1);
                                        break;
                                    }
                                }
                            };
                            // removeLink('acclarisSpendingAccountLink');
                            removeLink('alegeusSpendingAccountLink');

                        }
                    );
                }
			}());

			(function setHospitalQualityUrl() {
				var hospitalQualityMeasuresLink;
				for (var i = 0; i < navigation.data.providers.length; ++i) {
					if (navigation.data.providers[i].id === 'hospitalQualityMeasuresLink_ibc' || navigation.data.providers[i].id === 'hospitalQualityMeasuresLink') {
						hospitalQualityMeasuresLink = navigation.data.providers[i];
						break;
					}
				}
				if (hospitalQualityMeasuresLink) {
					services.eprsvc.hospitalQuality().getData().then(
						function(response){
							if (response && response.data && response.data.payload){
								hospitalQualityMeasuresLink.url =  response.data.payload;
							}
						},
						function(error){
							console.log('eprsvc.hospitalQuality failed with', error);
						}
					);
				}
			}());

			(function setProviderUrl() {
				for (var i = 0; i < navigation.data.providers.length; ++i) {
					var id = navigation.data.providers[i].id;
					if (id === 'findAProviderLink_ibc' || id === 'findAProviderLink_ahnj') {
						navigation.data.providers[i].configure(sessionData.employerInfo.planAdministrator.clientNumber);
						break;
					}
				}
			}());

			(function setDentalUrl() {
				for (var i = 0; i < navigation.data.providers.length; ++i) {
					var id = navigation.data.providers[i].id;
						if (id === 'dentalProviderLink') {
						var openModal = function() {
							modal.open({
								templateUrl: "_modals/dental.employerTemplate.html/modals/dentalModal",
								controller: require('../../modals/dentalModal'),
								scope: $scope
							});
						};
						navigation.data.providers[i].configure(openModal);
						break;
					}
				}
			}());


			$scope.fireCmElement = function(cmParams) {
				if (!cmParams || (typeof cmParams) != 'object') {
					return;
				} else {
					coremetrics.elementTag(cmParams.elementId, cmParams.theCategory);
				}
			};

		}
	]);

	return [
		{
			state: 'assistEmployees',
			url: '/assist-employees',
			postPassword: true,
			views: {
				'body@': {
					template: bootstrap.templates['page-templates/hmhs/landing-page.html'],
					controller: 'pages.assistEmployees'
				},
				'dashboard@assistEmployees': {
					template: require('pages/assistEmployees/assistEmployees.html')
				}
			}
		},
		{
			state: 'assistEmployees.benefitBooklets',
			url: '/benefit-booklets',
			postPassword: true,
			views: {
				'body@': {
					template: bootstrap.templates['page-templates/hmhs/content-page.html'],
					controller: 'pages.assistEmployees.benefitBooklets'
				},
				'content@assistEmployees.benefitBooklets': {
					templateUrl: 'assist-employees/benefit-booklets.employerTemplate.html/pages/assistEmployees/benefitBooklets'
				}
			}
		},
		{
			state: 'assistEmployees.changePcp',
			url: '/change-pcp',
			postPassword: true,
			params: { groupNumber: '', umi: '' },
			views: {
				'body@': {
					template: bootstrap.templates['page-templates/hmhs/landing-page.html'],
					controller: 'pages.assistEmployees.changePcp'
				},
				'dashboard@assistEmployees.changePcp': {
					templateUrl: 'assist-employees/change-pcp.employerTemplate.html/pages/assistEmployees/changePcp'
				}
			}
		},
		{
			state: 'assistEmployees.groupContracts',
			url: '/group-contracts',
			postPassword: true,
			views: {
				'body@': {
					template: bootstrap.templates['page-templates/hmhs/content-page.html'],
					controller: 'pages.assistEmployees.groupContracts'
				},
				'content@assistEmployees.groupContracts': {
					templateUrl: 'assist-employees/group-contracts.employerTemplate.html/pages/assistEmployees/groupContracts'
				}
			}
		},
		{
			state: 'assistEmployees.idCards',
			url: '/id-cards',
			postPassword: true,
			params: {umi:''},
			views: {
				'body@': {
					template: bootstrap.templates['page-templates/hmhs/content-page.html']
				},
				'content@assistEmployees.idCards': {
					templateUrl: 'assist-employees/id-cards.employerTemplate.html/pages/assistEmployees/idCards',
					controller: 'pages.assistEmployees.idCards'
				}
			}
		},
		{
			state: 'assistEmployees.preventiveMedications',
			url: '/preventive-medications',
			postPassword: true,
			views: {
				'body@': {
					template: bootstrap.templates['page-templates/hmhs/content-page.html'],
					controller   : 'pages.assistEmployees.preventiveMedications'
				},
				'content@assistEmployees.preventiveMedications': {
					templateUrl: 'assist-employees/preventive-medications.employerTemplate.html/pages/assistEmployees/preventiveMedications'
				}
			}
		},
		{
			state: 'assistEmployees.requestIdCard',
			url: '/request-id-card',
			postPassword: true,
			views: {
				'body@': {
					template: bootstrap.templates['page-templates/hmhs/content-page.html']
				},
				'content@assistEmployees.requestIdCard': {
					templateUrl: 'assist-employees/request-id-card.employerTemplate.html/pages/assistEmployees/requestIdCard'
				}
			}
		},
		{
			state: 'assistEmployees.spendingAccounts',
			url: '/spending-accounts',
			postPassword: true,
			params: { groupNumber: '', umi: '' },
			views: {
				'body@': {
					template: bootstrap.templates['page-templates/hmhs/landing-page.html'],
					controller: 'pages.assistEmployees.spendingAccounts'
				},
				'dashboard@assistEmployees.spendingAccounts': {
					templateUrl: 'assist-employees/spending-accounts.employerTemplate.html/pages/assistEmployees/spendingAccounts'
				}
			}
		},
		{
			state: 'assistEmployees.summaryOfBenefits',
			url: '/summary-of-benefits',
			postPassword: true,
			views: {
				'body@': {
					template: bootstrap.templates['page-templates/hmhs/content-page.html'],
					controller: 'pages.assistEmployees.summaryOfBenefits'
				},
				'content@assistEmployees.summaryOfBenefits': {
					templateUrl: 'assist-employees/summary-of-benefits.employerTemplate.html/pages/assistEmployees/summaryOfBenefits'
				}
			}
		},
		{
			state: 'assistEmployees.visionProvider',
			url: '/vision-provider',
			postPassword: true,
			views: {
				'body@': {
					template: bootstrap.templates['page-templates/hmhs/content-page.html'],
					controller: 'pages.assistEmployees.visionProvider'
				},
				'content@assistEmployees.visionProvider': {
					templateUrl: 'assist-employees/vision-provider.employerTemplate.html/pages/assistEmployees/visionProvider'
				}
			}
		}
	];
};
